export const UI_SET_LOADER = 'UI_SET_LOADER';
export const UI_SET_LOADER_TEXT = 'UI_SET_LOADER_TEXT';
export const SET_UI_PROPERTY = 'SET_UI_PROPERTY';
export const GET_MARKDOWN_FILE = 'GET_MARKDOWN_FILE';
export const UI_GET_TOWNS_BY_CP = 'UI_GET_TOWNS_BY_CP';
export const UI_UPDATE_TOWNS_BY_CP_CACHE = 'UI_UPDATE_TOWNS_BY_CP_CACHE';
export const UI_GET_MASTER_DATA = 'UI_GET_MASTER_DATA';
export const UI_UPDATE_MASTER_DATA = 'UI_UPDATE_MASTER_DATA';
export const UI_GET_CHEKINOUT_MASTER_DATA = 'UI_GET_CHEKINOUT_MASTER_DATA';
export const UI_GET_TIRES_MASTER_DATA = 'UI_GET_TIRES_MASTER_DATA';
export const RESET_INFORMATION_TIRES = 'RESET_INFORMATION_TIRES';
export const UI_GET_MUNICIPALITIES = 'UI_GET_MUNICIPALITIES';
